import { supabase } from './supabase';
import { uniqueChannelName } from './realtime';
import type { AiJobTrace } from './supabase.types';

export type { AiJobTrace };
export type AiJobTraceKind = AiJobTrace['kind'];

export async function fetchTracesForJob(jobId: string): Promise<AiJobTrace[]> {
  const { data, error } = await supabase
    .from('ai_job_traces')
    .select('*')
    .eq('job_id', jobId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error loading agent traces:', error);
    return [];
  }
  return (data ?? []) as AiJobTrace[];
}

export function tracesForKind(traces: AiJobTrace[], kind: AiJobTraceKind): AiJobTrace[] {
  return traces.filter((row) => row.kind === kind);
}

export function subscribeTracesForJob(jobId: string, onChange: () => void): () => void {
  const channel = supabase
    .channel(uniqueChannelName(`ai_job_traces:${jobId}`))
    .on(
      'postgres_changes',
      { event: '*', schema: 'public', table: 'ai_job_traces', filter: `job_id=eq.${jobId}` },
      onChange
    )
    .subscribe();
  return () => {
    supabase.removeChannel(channel);
  };
}
